// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import { Address, type AddressWireFormat, NewAddress } from '../Address/Address';
import {
  CompetitorInfo,
  type CompetitorInfoWireFormat,
  NewCompetitorInfo,
} from '../CompetitorInfo/CompetitorInfo';
import {
  type CompetitorProduct,
  type CompetitorProductWireFormat,
  NewCompetitorProduct,
} from '../CompetitorProduct/CompetitorProduct';

export class CompetitorPlant {
  readonly id: string;
  readonly competitor: CompetitorInfo;
  readonly name: string;
  readonly address: Address;
  readonly notes: string | null;
  readonly products: CompetitorProduct[];
  readonly isDeletable: boolean;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.competitor = NewCompetitorInfo(data.competitor);
    this.name = data.name === undefined ? '' : data.name;
    this.address = NewAddress(data.address);
    this.notes = data.notes === undefined ? null : data.notes;
    this.products = (data.products ?? []).map((products: any) => NewCompetitorProduct(products));
    this.isDeletable = data.isDeletable === undefined ? false : data.isDeletable;
  }

  static zero(): CompetitorPlant {
    const zeroValues: ExcludeMethodsDeep<CompetitorPlant> = {
      id: NIL_UUID,
      competitor: CompetitorInfo.zero(),
      name: '',
      address: Address.zero(),
      notes: null,
      products: [],
      isDeletable: false,
    };
    return new CompetitorPlant(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type CompetitorPlantWireFormat = {
  id: string;
  competitor: CompetitorInfoWireFormat;
  name: string;
  address: AddressWireFormat;
  notes: string | null;
  products: CompetitorProductWireFormat[];
  isDeletable: boolean;
};

type NewCompetitorPlantProps = PartialDeep<CompetitorPlant, { recurseIntoArrays: true }>;
export const NewCompetitorPlant: (props: NewCompetitorPlantProps) => CompetitorPlant = (props) =>
  new CompetitorPlant(props);

type NewCompetitorPlantFromWireFormatProps = PartialDeep<
  CompetitorPlantWireFormat,
  { recurseIntoArrays: true }
>;
export const NewCompetitorPlantFromWireFormat: (
  props: NewCompetitorPlantFromWireFormatProps,
) => CompetitorPlant = (props) => new CompetitorPlant(props);
